import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import clsx from 'clsx'
import _ from 'lodash'

import { BaseContext } from '../theme.context'
import { history } from '../../store'
import {
  FORM_SELECT_FORM,
  FORM_SELECT_POINT,
  FORM_ADD_QUESTIONS_VALUE,
  FORM_SET_STAGE,
  FINALIZE_FORM,
  FORM_SET_START_FORM,
  FORM_SET_STEP,
  FORM_CLEAN_FORM,
} from '../../actions'
import { getFlow } from './forms.utils'
import { FormsMergeWithState } from './forms.selector'
import AutoComplete from '../../Components/Autocomplete.component'
import StartFormComponent from './StartForm.component'
import SimpleModal from '../../Components/SimpleModalScroll.component'
import List from '../../Components/SimpleListItem.component'

const FormsButtons = ({
  onClickLeft,
  onClickRight,
  leftText,
  rightText,
  hideLeft,
  hideRight,
  disabledLeftbutton,
  disabledRightbutton,
}) => (
    <React.Fragment>
      {!hideLeft && (
        <Button
          color='secondary'
          variant='contained'
          onClick={onClickLeft}
          style={{ margin: '10px 5px 10px 0px' }}
          disabled={disabledLeftbutton}
        >
          {leftText}
        </Button>
      )}
      {!hideRight && (
        <Button
          color='secondary'
          variant='contained'
          onClick={onClickRight}
          style={{ margin: '10px 0px 10px 5px' }}
          disabled={disabledRightbutton}
        >
          {rightText}
        </Button>
      )}
    </React.Fragment>
  )

export class FormsContainer extends Component {
  constructor(props) {
    super(props)

    this.timer = {
      time: 0,
      id: null,
    }
    this.state = {
      showModal: false,
    }
  }

  static contextType = BaseContext

  onChangeStep = step => {
    const {
      steps,
      activeStep,
      onChangeStep,
    } = this.props

    onChangeStep(step >= 1 && step <= steps
      ? step
      : activeStep
    )
  }

  componentDidMount() {
    this.context.onChangeColor()
    this.context.onChangeleftButton(
      true,
      null,
      history.goBack,
    )
    this.timer.id = setInterval(() => this.timer.time += 1000, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.timer.id)
    this.props.cleanForm()
  }

  render = () => {
    const {
      formsOptions,
      classes,
      points,
      onSelectForm,
      onSelectPoint,
      formSelected,
      pointSelected,
      stageSelected,
      addQuestionsValue,
      questionsValue,
      prevStage,
      nextStage,
      finalizeForm,
      onChangeStage,
      onFinalizeForm,
      form,
      disabledNextButton,
      ending,
      onStartForm,
      formPointPending,
      activeStep,
      pointExtras,
    } = this.props
    const {
      showModal,
    } = this.state

    return (
      <Container fixed className={classes.fullHeight}>
        <SimpleModal
          open={showModal}
          onClose={() => this.setState({ showModal: false })}
          title='Extras del punto'
          content={(
            <List
              data={pointExtras}
              keyTitle='label'
              keyValue='value'
            />
          )}
        />
        <Grid
          container
          justify='center'
          className={clsx(classes.fullHeight, classes.root)}
        >
          {!ending && activeStep !== 3 && (
            <Grid
              container
              justify='center'
              alignItems='center'
              className={classes.fullHeight}
            >
              <Grid
                item
                xs={12}
              >
                {pointExtras.length > 0 && (
                  <Button
                    color='default'
                    variant='contained'
                    onClick={() => this.setState(state => ({
                      showModal: !state.showModal,
                    }))}
                    className={classes.pointExtras}
                  >
                    {'Ver extras del punto'}
                  </Button>
                )}
                {activeStep === 1 && (
                  <Paper className={classes.paper}>
                    <Typography gutterBottom variant='h5'>
                      {'Selecciona un formulario'}
                    </Typography>
                    <AutoComplete
                      id={'Forms-AutoComplete'}
                      selected={formSelected}
                      options={formsOptions}
                      onChange={onSelectForm}
                      placeholder='Selecciona un formulario...'
                      label='Formulario'
                      disabled={Boolean(formPointPending)}
                    />
                  </Paper>
                )}
                {activeStep === 2 && (
                  <Paper className={classes.paper}>
                    <Typography gutterBottom variant='h5'>
                      {'Selecciona un punto'}
                    </Typography>
                    <AutoComplete
                      id={'Forms-AutoComplete'}
                      selected={pointSelected}
                      options={points}
                      onChange={onSelectPoint}
                      placeholder='Selecciona un punto...'
                      label='Punto'
                      disabled={Boolean(formPointPending)}
                    />
                  </Paper>
                )}
                {activeStep !== 3 && (
                  <div className={classes.contentButton}>
                    <FormsButtons
                      onClickLeft={() => this.onChangeStep(activeStep - 1)}
                      onClickRight={() => this.onChangeStep(activeStep + 1)}
                      leftText='Atras'
                      disabledLeftbutton={activeStep === 1}
                      rightText='Siguiente'
                      disabledRightbutton={
                        (pointSelected && pointSelected.loading)
                        || (activeStep === 1 && !formSelected)
                        || (activeStep === 2 && !pointSelected)
                      }
                    />
                  </div>
                )}
              </Grid>
            </Grid>
          )}
          {!ending && activeStep === 3 && (
            <Grid
              container
              justify='center'
              alignItems='center'
              className={classes.fullHeight}
            >
              <Grid
                item
                xs={12}
              >
                {pointExtras.length > 0 && (
                  <Button
                    color='default'
                    variant='contained'
                    onClick={() => this.setState(state => ({
                      showModal: !state.showModal,
                    }))}
                    className={classes.pointExtras}
                  >
                    {'Ver extras del punto'}
                  </Button>
                )}
                <StartFormComponent
                  form={form}
                  questionsGroups={stageSelected.questionsGroups}
                  questionsValue={questionsValue}
                  onChange={addQuestionsValue}
                  onStartForm={onStartForm}
                />
                <div className={classes.contentButton}>
                  <FormsButtons
                    onClickLeft={() => {
                      prevStage
                        ? onChangeStage({
                          prevStage,
                          stageSelected,
                        })
                        : this.onChangeStep(activeStep - 1)
                    }}
                    onClickRight={() => {
                      form.type === 'flow'
                        ? nextStage && !finalizeForm
                          ? onChangeStage({ nextStage, stageSelected })
                          : finalizeForm && onFinalizeForm({
                            questionsGroups: stageSelected.questionsGroups,
                            stage_id: stageSelected._id,
                            form,
                            time: this.timer.time,
                          })
                        : onFinalizeForm({
                          questionsGroups: stageSelected.questionsGroups,
                          stage_id: stageSelected._id,
                          form,
                          time: this.timer.time,
                        })
                    }}
                    leftText='Atras'
                    disabledLeftbutton={activeStep === 1}
                    rightText={nextStage && !finalizeForm && form.type === 'flow'
                      ? 'Siguiente'
                      : 'Finalizar'
                    }
                    disabledRightbutton={disabledNextButton}
                  />
                </div>
              </Grid>
            </Grid>
          )}
          {ending && (
            <Grid
              container
              justify='center'
              alignItems='center'
              className={classes.fullHeight}
            >
              <Grid
                item
                xs={12}
              >
                <Typography gutterBottom variant='h5'>
                  {'Enviando formulario, espere un momento por favor...'}
                </Typography>
                <LinearProgress color='secondary' />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Container>
    )
  }
}

export const mapStateToProps = state => {
  const {
    Forms: {
      formSelected,
      pointSelected,
      stageSelected,
      abstractQuestionsGroup,
      questionsValue,
      finalizeForm,
      ending,
      formPointPending,
      steps,
      activeStep,
    },
    Points,
    Extras: {
      data: extras,
    },
  } = state
  const { forms, formsKeyed } = FormsMergeWithState(state)
  const form = formsKeyed[(formSelected || {}).value]
  const result = getFlow(form, {
    formSelected,
    pointSelected,
    stageSelected,
    abstractQuestionsGroup,
    questionsValue,
    finalizeForm,
    Points,
    forms,
    formPointPending,
  })

  const allQuestions = _.flattenDeep(result.stageSelected.questionsGroups.map(qg => qg.questions))
  const allQuestionsFilter = _.filter(
    allQuestions,
    question => question.required && !result.questionsValue[question._id],
  )
  const pointExtras = pointSelected
    ? extras[pointSelected.value] || []
    : []

  return {
    ...result,
    form,
    disabledNextButton: Boolean(allQuestionsFilter.length),
    ending,
    formPointPending,
    steps,
    activeStep,
    pointExtras,
    pointSelected,
  }
}

export const mapDispatchToProps = dispatch => ({
  onSelectPoint: payload => dispatch(FORM_SELECT_POINT(payload)),
  onSelectForm: payload => dispatch(FORM_SELECT_FORM(payload)),
  addQuestionsValue: payload => dispatch(FORM_ADD_QUESTIONS_VALUE(payload)),
  onChangeStage: payload => dispatch(FORM_SET_STAGE(payload)),
  onFinalizeForm: payload => dispatch(FINALIZE_FORM(payload)),
  onStartForm: payload => dispatch(FORM_SET_START_FORM(payload)),
  onChangeStep: payload => dispatch(FORM_SET_STEP(payload)),
  cleanForm: () => dispatch(FORM_CLEAN_FORM()),
})

const styles = theme => ({
  root: {
    boxSizing: 'border-box',
    padding: 25,
  },
  fullHeight: { height: '100%' },
  paper: {
    boxSizing: 'border-box',
    padding: 25,
  },
  contentForm: {
    maxHeight: 'calc(100% + 56px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflowY: 'scroll',
  },
  contentButton: {
    marginTop: theme.spacing(2),
    float: 'right',
  },
  pointExtras: {
    margin: `${theme.spacing(2)}px 0`,
  },
})

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(FormsContainer)
